module.exports = __webpack_public_path__ + "static/img/memberType1.585a97e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person/memberType1.png
// module id = 1YJw
// module chunks = 1